import * as React from "react"
import "../styles.css"
import * as pageStyles from "../page_css/page.css"
import * as styles from "./page-hero.css"
import { theme } from "../theme.css"
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image"
import { colorArrayToString } from "../utils"
import { TColor } from "../types"
import Flash from "../components/flash"
import StandardCard from "../components/blocks/StandardCard"
import TicketLink  from "../components/ticket-link"
import Bumbershoot2024BlueAnim from "../graphics/Bumbershoot-2024-blue-anim.svg"
import LineupNav from "../components/lineup-nav"

import {
  NavLink,
  VisuallyHidden,
} from "./ui"
import * as stylesHeader from "./header.css"
import Badge from "./badge"

interface PageHeroProps {
  title: string
  subtitle?: string
  hidePageTitle?: boolean
  image: {
    id: string
    title: string
    gatsbyImageData?: any,
    localfile?: any
  },
  overlayColor?: string | TColor
  overlayOpacity?: string,
  showPageHero?: boolean,
  showPageHeroVideo?: boolean,
  heroVideoYoutubeUrl?: string,
  heroCard?: any,
  showHeroType?: string
  ticketLinks?: string
  path?: string
  location?: string
}

//homeHero2023
const ImageHero:React.FC<PageHeroProps> = (props) => {
  return (
    <>
    { props.image && props.showPageHero && (
      <div className={styles.customHomepageImageBlock}>
        <GatsbyImage
          className={styles.pageHeroImage}
          style={{marginTop: '-100px'}}
          alt={props.image.title}
          image={getImage(props.image)}
        />
          <div className={styles.overlayContent} style={{gap:"10px"}}>
            <div style={{width: "100%", height:"auto"}}>
              <h1 className={styles.heroTitleStyle}>GA Weekend Passes $225* +Fees</h1>
              <h2 className={styles.heroTitleH2Style}>for</h2>
              <h1 className={styles.heroTitleStyleSmall}>Bumbershoot</h1>
              <h1 className={styles.heroTitleStyleSmaller}>Arts &amp; Music Festival</h1>
              <h1 className={styles.heroTitle2025Style}>2025</h1>
              {
              /*
                <div style={{width: "200px", display: "inline-block"}}>
                  <Bumbershoot2024BlueAnim />
                </div>
              */
             }
            </div>
          
            <div className={styles.heroButtonWrapper}>
                <div className={styles.heroButton}>
                  <NavLink to="https://wl.seetickets.us/wafform.aspx?afflky=ThirdStone&_act=subpromoterev3&_pky=618086&sp=8TSXH4" target="_blank">
                    <VisuallyHidden>TICKETS!</VisuallyHidden>
                      <span className={styles.heroBadge}>
                       TICKETS!
                      </span>
                  </NavLink>
                </div>
            </div>
            <div style={{width: "100vw", maxWidth:"700px"}} className={styles.heroTitle}>Limited Time Only</div>        
          </div>
      </div>
    )}
   </>
  )
}


const VideoHero:React.FC<PageHeroProps> = (props) => {
  return (
    <>
    { props.heroVideoYoutubeUrl && (
      <>
        <div className={styles.customHomepageVideoBlock}>
          <iframe 
            className={styles.customHomepageVideoIframeWrapper}  
            src={props.heroVideoYoutubeUrl} 
            title="Bumbershoot Video" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowFullScreen>
          </iframe>
        </div>
      </>
    )}
    </>
  )
}

const HeadlineHero:React.FC<PageHeroProps> = (props) => {
  return (
    <>
    { props.title && (props?.hidePageTitle !== true) && (
      <h1 className={styles.pageHeroTitle}>{props.title}</h1>
    )}
    { props.subtitle && (props?.hidePageTitle !== true) && (
      <h1 className={styles.pageHeroSubtitle}>{props.subtitle}</h1>
    )}

    </>
  )
}

const CardHero:React.FC<PageHeroProps> = (props) => { 
  console.log("video hero props", props);
  const { location } = props;
  const firstCardDataElement = props?.heroCard?.[0].card?.cardData?.[0] ?? [];
  const { video: { video: videoObj = {} } = {}, videoThumbnail = {}, buttonText = '', title='', text='', hasButton=false } = firstCardDataElement; //video is a nested object btw.
  const { mp4Low = '', mp4Med = '' } = videoObj;
  const videoThumbnailSrc = videoThumbnail.gatsbyImageData?.images?.fallback?.src ?? "";
  const { ticketLinks } = props;

  return (
    <>
  { firstCardDataElement &&
  (
    <>
      <div className={styles.heroContainer}>
        {/*
        <GatsbyImage
          image={getImage(cardData[0].backgroundImage)}
          className={styles.heroImage}
          style={{
          }}
          alt="props.heroCard[0].backgroundImage.title"
        />
        mp4Med: "https://stream.mux.com/wth005nT4lBr4pp26MQqxb8wYXjeNUq02f/medium.mp4"
        */}
        <video 
          autoPlay 
          muted 
          loop 
          playsInline 
          style={{ width: '100vw', position: 'static', objectFit: 'cover', height: '95vh' }}
          poster={videoThumbnailSrc}
          >
          <source src={mp4Med} type="video/mp4" />
          </video>
          <div className={styles.overlayContent} style={{gap:"10px"}}>
            <div style={{width: "100%", height:"auto"}}>
              <h1 className={styles.heroTitleStyle}>GA Weekend Passes $225* +Fees</h1>
              <h2 className={styles.heroTitleH2Style}>for</h2>
              <h1 className={styles.heroTitleStyleSmall}>Bumbershoot</h1>
              <h1 className={styles.heroTitleStyleSmaller}>Arts &amp; Music Festival</h1>
              <h1 className={styles.heroTitle2025Style}>2025</h1>
              {
              /*
                <div style={{width: "200px", display: "inline-block"}}>
                  <Bumbershoot2024BlueAnim />
                </div>
              */
             }
            </div>
          
            <div className={styles.heroButtonWrapper}>
                <div className={styles.heroButton}>
                  <NavLink to="https://wl.seetickets.us/wafform.aspx?afflky=ThirdStone&_act=subpromoterev3&_pky=618086&sp=8TSXH4" target="_blank">
                    <VisuallyHidden>TICKETS!</VisuallyHidden>
                      <span className={styles.heroBadge}>
                       TICKETS!
                      </span>
                  </NavLink>
                </div>
            </div>
            <div style={{width: "100vw", maxWidth:"700px"}} className={styles.heroTitle}>*Limited Time Only</div>        
          </div>
        </div>
    {/*
      {props.title == "Bumbershoot" &&  (
        <>
        <div style={{maxWidth: "700px"}}>
          <h1 className={styles.pageHeroTitle} style={{ textAlign: "center", padding: "20px"}}>Bumbershoot Returns Aug. 31 + Sept. 1, 2024</h1>
          <h2 style={{ textAlign: "center", padding:"0 20px"}}>Last year's reinvention of Bumbershoot was epic—and we couldn't have done it without you. </h2>
          <h3 style={{ textAlign: "center", padding: "10px 20px"}}>We return bigger and bolder this Labor Day weekend for our annual celebration of the artists, dreamers and makers who call the pacific northwest home. Join us for another full-spectrum arts and music experience- it will be a visual and sonic feast!</h3>
        </div>
      </>
      )}
        */}
        {
        /* resuse for next year.
          <LineupNav currentPath={location}/>
        */
        }
    </>
  )}
  </>
  )
}

const PageHero: React.FC<PageHeroProps> = (props) => {
  const ticketLinks = TicketLink();
  const { showHeroType } = props;

  switch (showHeroType) { 
   // case "no_hero":
   //   return null;
    case "image_hero":
      return (<ImageHero {...props} />);
    case "video_hero":
      return (<VideoHero {...props} />);
    case "card_hero":
      return (<CardHero {...props} ticketLinks={ticketLinks}/>);
    case "headline_hero":
      return (<HeadlineHero {...props} />);
    default:
      return (<HeadlineHero {...props} />);
  }

}

export default PageHero
